/**
 * Demo uploads: sample files a visitor sent for a requirement, under
 * `public/demo/uploads`. The insurer and the card's register are made up,
 * and both files say they're samples.
 */

import type { UploadedFile } from '../visits/visit-detail-panel/admission';

/**
 * Demo: the file behind a row waiting for review (`NEEDS_API.uploads`). A
 * sample PDF for insurance, a sample card photo for anything else, so the
 * review shows both kinds of file.
 */
export function demoUpload(
  requirement: string,
  uploader: string | null,
  detail = '',
): UploadedFile {
  // The row's own words set the time ("Uploaded today 08:02"); else yesterday evening.
  const today = /today (\d{1,2}):(\d{2})/i.exec(detail);
  const at = new Date();
  if (today) at.setHours(Number(today[1]), Number(today[2]), 0, 0);
  else {
    at.setDate(at.getDate() - 1);
    at.setHours(18, 42, 0, 0);
  }
  const pdf = /insurance/i.test(requirement);
  return {
    url: pdf ? 'demo/uploads/insurance-certificate.pdf' : 'demo/uploads/skills-card.jpg',
    fileName: pdf ? 'Insurance certificate.pdf' : 'Card.jpg',
    mimeType: pdf ? 'application/pdf' : 'image/jpeg',
    uploadedAt: at.toISOString(),
    uploadedBy: uploader,
  };
}
